<template>
    <div>
        <div class="bulletinBoard">
            <div class="head">
                <div class="title" :style="'background:'+option.color">{{option.title}}（{{total}}）</div>
                <div class="moneyInfo">
                    <div class="detailInfo">
                        <div style="width:70px">合同金额</div>
                        <div class="money">
                          <div class="signLable">￥</div>
                          <div>
                            {{tool.money_format_allowvoid(info.moneySum ) }}
                          </div>
                        </div>
                    </div>
                    <div class="detailInfo">
                        <div style="width:70px">已结算金额</div>
                        <div class="money">
                          <div class="signLable">￥</div>
                          <div>{{ tool.money_format_allowvoid(info.settledAmountSum )}}</div>
                        </div>
                    </div>
                    <div class="detailInfo">
                        <div style="width:70px">未结算金额</div>
                        <div class="money">
                          <div class="signLable">￥</div>
                          <div>
                            {{ tool.money_format_allowvoid(info.unsettledAmountSum )}}
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="" style="position: relative;">
                
                <ul  @scroll='handleScroll($event)' class=" bulletinBoard-content " :style="`height:${height*7}px`"  :infinite-scroll-distance="0" v-infinite-scroll="load"   >
                        <div>
                        <li v-for="(i,index) in list" class="" :key="index"><card :item="i" :color="option.color" v-on="$listeners" :projectContractTypeList="projectContractTypeList"></card></li>

                        </div>
                       <!-- <div class="el-icon-loading" v-show="!loadFlag&&total!=list.length"></div> -->
                      <div class="notice" v-if="!loadFlag" >已经到底了</div>
                        
                       
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import card from './card.vue';

export default {
  props: {
    option: {},
    list: {
      default: [],
    },
    total: {
      default: 0,
      type: Number,
    }, //列表总数
    loadFlag: {
      default: true,
    },
    info: {},
    projectContractTypeList: {
      default: [],
    },
    clearCurrent:{
        default:false,
        type:Boolean
    },
    scrollBottom:{
      default:false,
      type:Boolean
    }
  },
  components: {
    card,
  },
  watch:{
    clearCurrent(){
        this.clearCur()
    },
    '$store.state.windowSize.screenWidth': function (val) { //监听屏幕宽度变化
          console.log("屏幕的宽度",val)
          this.width = val/10;
           this.$forceUpdate()
      },
    '$store.state.windowSize.screenHeight': function (val) { //监听屏幕高度变化
        console.log("屏幕的高度",val)
        this.height = val/10;
          this.$forceUpdate()
      }
    // total(){
    //   if(this.total<4||this.total==0){
    //   this.scrollBottom = true
    //   console.log(this.total,this.scrollBottom)
    // }
    // }
  },
  data() {
    return {
      current: 1, //
      timer: undefined,
      width:'',
      height:'',
      // scrollBottom:false,
    };
  },
  created(){
        this.width =  document.documentElement.clientWidth/10; 
        this.height =document.documentElement.clientHeight/10;
  },
  mounted(){
    if(this.total<0){
      this.scrollBottom = true
      console.log(this.total,this.scrollBottom)
    }
  },
  methods: {
    handleScroll(e){
      
      if((e.srcElement.scrollTop + e.srcElement.offsetHeight >= e.srcElement.scrollHeight)&&!this.loadFlag){
        console.log('到底了')
        this.scrollBottom = true
      }else{
        this.scrollBottom = false
      }
    },
    load() {
      console.log('触发了loadFlag', this.loadFlag);
      if (this.loadFlag) {
        console.log('触发了');

        this.$emit('onLoad', ++this.current);
      }
      this.$forceUpdate();
    },
    //清除页码
    clearCur(){
        this.current=1
    }
  },
};
</script>

<style lang="scss" scoped>
.notice {
  font-size: 12px;
  font-family: 'Segoe UI';
  font-weight: 400;
  // line-height: 16px;
  text-align: center;
  color: #c0c4cc;
  // position: absolute;
  // margin: 0 16px;
  // bottom: 0;
  &::before {
    content: '';
    display: inline-block;
    width: 128px;
    height: 1px;
    background: #e4e7ed;
    margin-bottom: 4px;
  }
  &::after {
    content: '';
    display: inline-block;
    width: 128px;
    height: 1px;
    background: #e4e7ed;
    margin-bottom: 4px;
  }
}
.infinite-list {
}
.bulletinBoard {
  background-color: #f2f6fc;
  border: 1px solid #e4e7ed;
  // width: 360px;
  min-width: 360px;
  width: 100%;
  .bulletinBoard-content {
    width: 100%;
    // height: 542px;
    // margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 16px;
    overflow: auto;
    li {
      margin-bottom: 16px;
    }
  }
}
.head {
  // width: 360px;
  min-width: 360px;
  width: 100%;
  .title {
    font-size: 14px;
    font-family: 'Microsoft YaHei UI';
    font-weight: 400;
    height: 34px;
    min-width: 360px;
    // width: 360px;
    width: 100%;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .moneyInfo {
    // width: 360px;
    width: 100%;
    border: 1px solid #dcdfe6;
    border-top: none;
    font-size: 14px;
    font-family: 'Microsoft YaHei UI';
    font-weight: 400;
    color: #303133;
    padding: 16px;
    display: grid;
    grid-template-rows: repeat(3, 18px);
    grid-row-gap: 8px;
    box-sizing: border-box;
    .detailInfo {
      display: grid;
      grid-template-columns: 1fr 1fr;
      .money {
        justify-self: end;
        display: flex;
        justify-content: space-between;
        .signLable{
          margin-right: 2px;
        }
      }
    }
  }
}
</style>
